import { Dropdown, Collapse, Modal, Offcanvas, Carousel } from 'bootstrap';

//Components
import '../scss/theme.scss';
import './components/off-canvas.js';
import './components/sticky-header.js';

//Images
import '../image/TU_MMM_Logo.png';
import '../image/TU_MMM_Logo_white.png';
import '../image/hero-image.png';
import '../image/test-image.png';
import '../image/cta-img.png';
import '../image/leadership-slide-img.png';
import '../image/leadership-slide-img-2.png';
import '../image/innovation-diagram.svg';
import '../image/tu-sheild-outline.svg';
 

import '../image/tueehl-b-roll.mp4';



window.addEventListener('DOMContentLoaded', function() {
	//SVG INJECTOR
	const elementsToInject = document.querySelectorAll('.inject-me');
	const injectorOptions = {
		evalScripts: 'once'
	};
	let injector = new SVGInjector(injectorOptions);
	if (elementsToInject.length) {
		injector.inject(elementsToInject);
	}
}, false);



	jQuery('.faculty-select').on('change', function() {
		var url = $(this).val();
		if (url) {
			window.location = url;
		}
		return false;
	});



// jQuery('select').on('change', function(e){
// 	console.log(this.value,
// 				this.options[this.selectedIndex].value,
// 				jQuery(this).find("option:selected").val(),);
//   });